import React, { useState, useEffect, Children } from "react";
import { EmployeeTeamVM } from "../../Models/ViewModels";
import {
  Table,
  Pagination,
  Stack,
  Avatar,
  Input,
  Button,
  Toggle,
  Whisper,
  Tooltip,
} from "rsuite";
import * as TeamDB from "../../Services/EmployeeDB";
import { PageHeader } from "../../SharedComponents/PageHeader";
import * as XLSX from "xlsx";
import { TeamCard } from "./TeamCard";
import { TeamDetailSimple } from "./TeamDetailSimple";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { Modal } from "react-bootstrap";
import { TeamMembers } from "./TeamMembers";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { CustomTableHeaderCells } from "../../SharedComponents/ToolTipForColumnGroup";
const { Column, HeaderCell, Cell, ColumnGroup } = Table;
const colors = ["pink", "grey", "blue", "yellow", "purple", "green", "red"];

export const TeamDetails = ({ name, designation, department }: any) => {
  const proc: any = [];
  const proc1: any = [];
  const [cachedTeamList, setCachedTeamList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [processName, setProcessName] = useState(new Array<EmployeeTeamVM>());
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredTeamList, setFilteredTeamList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [checked, setChecked] = useState(false);
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [popup, setPopUp] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [searching, setSearching] = useState(false);
  useEffect(() => {
    getAllTeamList(loginid);
  }, []);

  const handleClose = () => setPopUp(false);
  const filterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredTeamList(
        cachedTeamList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredTeamList([...cachedTeamList]);
      setSearching(false);
    }
  };

  const tableDataFeed = filteredTeamList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getProcessCount = (processesArray: any[], processName: string) => {
    for (let i = 0; i < processesArray.length; i++) {
      if (processesArray[i].ProcessName === processName) {
        return processesArray[i].ProcessCount;
      }
    }
    return "";
  };

  const getNonProductionCount = (
    processesArray: any[],
    processName: string
  ) => {
    for (let i = 0; i < processesArray.length; i++) {
      if (processesArray[i].ProcessName === processName) {
        return processesArray[i].NonProduction;
      }
    }
    return "";
  };
  const getFTE = (processesArray: any[], processName: string) => {
    for (let i = 0; i < processesArray.length; i++) {
      if (processesArray[i].ProcessName === processName) {
        return processesArray[i].FTEAllo;
      }
    }
    return "";
  };
  const getFTEBuff = (processesArray: any[], processName: string) => {
    for (let i = 0; i < processesArray.length; i++) {
      if (processesArray[i].ProcessName === processName) {
        return processesArray[i].FTEBuff;
      }
    }
    return "";
  };

  const getAllTeamList = (loginid: any) => {
    TeamDB.GetTeamDetails(loginid)
      .then((res: any) => {
        if (res) {
          res = res.data;
          for (let i = 0; i < res.length; i++) {
            res[i].TotalHC =
              +getProcessCount(res[i].Processes, "ALL") +
              +getProcessCount(res[i].Processes, "AR") +
              +getProcessCount(res[i].Processes, "Coding") +
              +getProcessCount(res[i].Processes, "CP") +
              +getProcessCount(res[i].Processes, "Demo") +
              +getProcessCount(res[i].Processes, "Denials") +
              +getProcessCount(res[i].Processes, "Credentialing") +
              +getProcessCount(res[i].Processes, "NA") +
              +getProcessCount(res[i].Processes, "Other") +
              +getProcessCount(res[i].Processes, "PFS") +
              +getProcessCount(res[i].Processes, "PP") +
              +getProcessCount(res[i].Processes, "Statements");

            res[i].TotalHCFTEAllocation =
              +getFTE(res[i].Processes, "ALL") +
              +getFTE(res[i].Processes, "AR") +
              +getFTE(res[i].Processes, "Coding") +
              +getFTE(res[i].Processes, "Credentialing") +
              +getFTE(res[i].Processes, "CP") +
              +getFTE(res[i].Processes, "Demo") +
              +getFTE(res[i].Processes, "Denials") +
              +getFTE(res[i].Processes, "NA") +
              +getFTE(res[i].Processes, "Other") +
              +getFTE(res[i].Processes, "PP") +
              +getFTE(res[i].Processes, "Statements") +
              +getFTE(res[i].Processes, "PFS");

            res[i].TotalHCFTEBuffer =
              +getFTEBuff(res[i].Processes, "AR") +
              +getFTEBuff(res[i].Processes, "ALL") +
              +getFTEBuff(res[i].Processes, "Coding") +
              +getFTEBuff(res[i].Processes, "Credentialing") +
              +getFTEBuff(res[i].Processes, "PP") +
              +getFTEBuff(res[i].Processes, "Demo") +
              +getFTEBuff(res[i].Processes, "Denials") +
              +getFTEBuff(res[i].Processes, "NA") +
              +getFTEBuff(res[i].Processes, "Others") +
              +getFTEBuff(res[i].Processes, "CP") +
              +getFTEBuff(res[i].Processes, "Statements") +
              +getFTEBuff(res[i].Processes, "PFS");
            res[i].ALL = +getProcessCount(res[i].Processes, "ALL");
            res[i].ALLFTEAllocation = +getFTE(res[i].Processes, "ALL");
            res[i].ALLFTEBuffer = +getFTEBuff(res[i].Processes, "ALL");

            res[i].AR = +getProcessCount(res[i].Processes, "AR");
            res[i].ARFTEAllocation = +getFTE(res[i].Processes, "AR");
            res[i].ARFTEBuffer = +getFTEBuff(res[i].Processes, "AR");

            res[i].Coding = +getProcessCount(res[i].Processes, "Coding");
            res[i].CodingFTEAllocation = +getFTE(res[i].Processes, "Coding");
            res[i].CodingFTEBuffer = +getFTEBuff(res[i].Processes, "Coding");

            res[i].CP = +getProcessCount(res[i].Processes, "CP");
            res[i].CPFTEAllocation = +getFTE(res[i].Processes, "CP");
            res[i].CPFTEBuffer = +getFTEBuff(res[i].Processes, "CP");

            res[i].Demo = +getProcessCount(res[i].Processes, "Demo");
            res[i].DemoFTEAllocation = +getFTE(res[i].Processes, "Demo");
            res[i].DemoFTEBuffer = +getFTEBuff(res[i].Processes, "Demo");

            res[i].Denials = +getProcessCount(res[i].Processes, "Denials");
            res[i].DenialsFTEAllocation = +getFTE(res[i].Processes, "Denials");
            res[i].DenialsFTEBuffer = +getFTEBuff(res[i].Processes, "Denials");

            res[i].Credentialing = +getProcessCount(
              res[i].Processes,
              "Credentialing"
            );
            res[i].CredentialingFTEAllocation = +getFTE(
              res[i].Processes,
              "Credentialing"
            );
            res[i].CredentialingFTEBuffer = +getFTEBuff(
              res[i].Processes,
              "Credentialing"
            );

            res[i].NA = +getProcessCount(res[i].Processes, "NA");
            res[i].NAFTEAllocation = +getFTE(res[i].Processes, "NA");
            res[i].NAFTEBuffer = +getFTEBuff(res[i].Processes, "NA");

            res[i].Other = +getProcessCount(res[i].Processes, "Other");
            res[i].OtherFTEAllocation = +getFTE(res[i].Processes, "Other");
            res[i].OtherFTEBuffer = +getFTEBuff(res[i].Processes, "Other");

            res[i].PFS = +getProcessCount(res[i].Processes, "PFS");
            res[i].PFSFTEAllocation = +getFTE(res[i].Processes, "PFS");
            res[i].PFSFTBuffer = +getFTEBuff(res[i].Processes, "PFS");

            res[i].PP = +getProcessCount(res[i].Processes, "PP");
            res[i].PPFTEAllocation = +getFTE(res[i].Processes, "PP");
            res[i].PPFTEBuffer = +getFTEBuff(res[i].Processes, "PP");

            res[i].Statements = +getProcessCount(
              res[i].Processes,
              "Statements"
            );
            res[i].StatementsFTEAllocation = +getFTE(
              res[i].Processes,
              "Statements"
            );
            res[i].StatementsFTEBuffer = +getFTEBuff(
              res[i].Processes,
              "Statements"
            );

            res[i].NonProduction =
              +getNonProductionCount(res[i].Processes, "ALL") +
              +getNonProductionCount(res[i].Processes, "AR") +
              +getNonProductionCount(res[i].Processes, "Coding") +
              +getNonProductionCount(res[i].Processes, "Denials") +
              +getNonProductionCount(res[i].Processes, "CP") +
              +getNonProductionCount(res[i].Processes, "Demo") +
              +getNonProductionCount(res[i].Processes, "Credentialing") +
              +getNonProductionCount(res[i].Processes, "NA") +
              +getNonProductionCount(res[i].Processes, "Other") +
              +getNonProductionCount(res[i].Processes, "PFS") +
              +getProcessCount(res[i].Processes, "Statements") +
              +getNonProductionCount(res[i].Processes, "PP");
            res[i].Total = res[i].TotalHC - res[i].NonProduction;
          }

          setCachedTeamList(res);
          setFilteredTeamList(res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setTimeout(() => {
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return cachedTeamList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };
  const handelDetailsPopUp = (rowData: any, loginid: any) => {
    TeamDB.GetTeamMembersDetails(rowData.Team, loginid).then((res) => {
      setTeamMembers(res.data);
      setPopUp(true);
    });
  };
  return (
    <>
      <div className="row">
        <div className="col-md-7">
          <PageHeader title="Team Allocation Details" backPage="">
            <></>
          </PageHeader>
        </div>
        {!checked ? (
          <div className="col-md-3">
            <Input
              className="form-control w-100 "
              type="search"
              autoFocus={true}
              placeholder={"Search team...."}
              onChange={filterData}
            />
          </div>
        ) : (
          <div className="col-md-3 "></div>
        )}
        {!checked ? (
          <div className="col-md-1">
            {searching == true ? (
              <button
                id="color"
                onClick={() => handleDownloadAsExcel(tableDataFeed)}
              >
                <BootstrapIcon
                  bootStrapIconName={"file-earmark-arrow-down-fill"}
                  size={30}
                  cssClasses={"pe-2"}
                />{" "}
              </button>
            ) : (
              <button
                id="color"
                onClick={() => handleDownloadAsExcel(cachedTeamList)}
              >
                <BootstrapIcon
                  bootStrapIconName={"file-earmark-arrow-down-fill"}
                  size={30}
                  cssClasses={"pe-2"}
                />{" "}
              </button>
            )}
          </div>
        ) : (
          <div className="col-md-2"></div>
        )}

        <div className="col">
          <Toggle
            size="lg"
            checkedChildren="Table"
            unCheckedChildren="Cards"
            onChange={(checked: boolean, event) => setChecked(checked)}
          />
        </div>
        <hr />
      </div>

      {!checked ? (
        <div>
          <Modal show={popup} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Team Members</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <TeamMembers members={teamMembers} />
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-danger" onClick={handleClose}>
                Close
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleDownloadAsExcel(cachedTeamList)}
              >
                Export To Excel
              </button>
            </Modal.Footer>
          </Modal>

          <div className="show-container">
            <div className="row mx">
              <div className="col-md-11"></div>
              <div className="col-md-1 ">
                {" "}
                Head Count
                <br />
                <span className="text-success">(Allocation FTE)</span>
                <p className="text-danger">(Buffer FTE)</p>
              </div>
              <div className="col-md-1 text-success"></div>

              <div className="col-md-1 text-danger"></div>
            </div>

            {cachedTeamList.length > 0 ? (
              <Table
                id="table"
                height={480}
                data={tableDataFeed}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
                loading={isLoading}
                bordered={true}
                cellBordered={true}
                className="border border-dark mt-2"
                // autoHeight={true}
                rowHeight={59}
                headerHeight={60}
                onRowClick={(rowData: any) => {
                  handelDetailsPopUp(rowData, loginid);
                }}
              >
                <Column flexGrow={300} align="left" fixed sortable>
                  <CustomTableHeaderCells>
                    <Whisper followCursor speaker={<Tooltip>Team</Tooltip>}>
                      <span>Team</span>
                    </Whisper>
                  </CustomTableHeaderCells>

                  <CustomTableCell>
                    {(rowData: any) => {
                      return <a href="#">{rowData.Team}</a>;
                    }}
                  </CustomTableCell>
                </Column>
                <Column align="center" flexGrow={70} fixed>
                  <CustomTableHeaderCells>
                    <Whisper followCursor speaker={<Tooltip>Total HC</Tooltip>}>
                      <span>Total HC</span>
                    </Whisper>
                  </CustomTableHeaderCells>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div className="row">
                          {rowData.TotalHC > 0 ? (
                            <div>
                              <div className="col-md-0">{rowData.TotalHC}</div>
                              {rowData.TotalHCFTEAllocation > 0 ? (
                                <div className="col-md-0 text-success">
                                  ({rowData.TotalHCFTEAllocation.toFixed(2)})
                                </div>
                              ) : (
                                0
                              )}
                              {rowData.TotalHCFTEBuffer > 0 ? (
                                <div className="col-md-0 text-danger">
                                  ({rowData.TotalHCFTEBuffer})
                                </div>
                              ) : (
                                0
                              )}
                            </div>
                          ) : (
                            <div className="col">{rowData.TotalHC}</div>
                          )}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={130} align="center" fixed>
                  <CustomTableHeaderCells>
                    <Whisper
                      followCursor
                      speaker={
                        <Tooltip>Non-production /(Manager/Lead HC)</Tooltip>
                      }
                    >
                      <span>
                        {" "}
                        Non-production
                        <br />
                        (Manager/Lead HC)
                      </span>
                    </Whisper>
                  </CustomTableHeaderCells>
                  <CustomTableCell dataKey="NonProduction" />
                </Column>
                <ColumnGroup header="Production HC by Process" align="center">
                  <Column flexGrow={50} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>All</Tooltip>}>
                        <span>All</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.ALL > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.ALL}</div>
                                {rowData.ALLFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.ALLFTEAllocation})
                                  </div>
                                ) : null}
                                {rowData.ALLFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.ALLFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.ALL}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>
                  <Column flexGrow={50} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>AR</Tooltip>}>
                        <span>AR</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {/* {
                                          console.log(rowData.ARFTEAllocation)

                    } */}
                            {rowData.AR > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.AR}</div>
                                {rowData.ARFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.ARFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.ARFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.ARFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col text-center">
                                {rowData.AR}
                              </div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>
                  <Column flexGrow={70} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>Coding</Tooltip>}>
                        <span>Coding</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.Coding > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.Coding}</div>
                                {rowData.CodingFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.CodingFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.CodingFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.CodingFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col text-center">
                                {rowData.Coding}
                              </div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>
                  <Column flexGrow={50} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>CP</Tooltip>}>
                        <span>CP</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.CP > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.CP}</div>
                                {rowData.CPFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.CPFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.CPFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.CPFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.CP}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>

                  <Column flexGrow={104} fixed>
                    <CustomTableHeaderCells>
                      <Whisper
                        followCursor
                        speaker={<Tooltip>Credentialing</Tooltip>}
                      >
                        <span>Credentialing</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.Credentialing > 0 ? (
                              <div>
                                <div className="col-md-0">
                                  {rowData.Credentialing}
                                </div>
                                {rowData.CredentialingFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.CredentialingFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.CredentialingFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.CredentialingFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.Credentialing}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>

                  <Column flexGrow={60} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>Demo</Tooltip>}>
                        <span>Demo</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="  row">
                            {rowData.Demo > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.Demo}</div>
                                {rowData.DemoFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.DemoFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.DemoFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.DemoFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.Demo}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>

                  <Column flexGrow={70} fixed>
                    <CustomTableHeaderCells>
                      <Whisper
                        followCursor
                        speaker={<Tooltip>Denails</Tooltip>}
                      >
                        <span>Denails</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.Denials > 0 ? (
                              <div>
                                <div className="col-md-0">
                                  {rowData.Denials}
                                </div>
                                {rowData.DenialsFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.DenialsFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.DenialsFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.DenialsFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.Denials}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>

                  <Column flexGrow={50} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>PFS</Tooltip>}>
                        <span>PFS</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.PFS > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.PFS}</div>
                                {rowData.PFSFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.PFSFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.PFSFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.PFSFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.PFS}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>

                  <Column flexGrow={40} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>PP</Tooltip>}>
                        <span>PP</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.PP > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.PP}</div>
                                {rowData.PPFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.PPFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.PPFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.PPFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.PP}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>

                  <Column flexGrow={90} fixed>
                    <CustomTableHeaderCells>
                      <Whisper
                        followCursor
                        speaker={<Tooltip>Statements</Tooltip>}
                      >
                        <span>Statements</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.Statements > 0 ? (
                              <div>
                                <div className="col-md-0">
                                  {rowData.Statements}
                                </div>
                                {rowData.StatementsFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.StatementsFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.StatementsFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.StatementsFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.Statements}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>
                  <Column flexGrow={60} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>Other</Tooltip>}>
                        <span>Other</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.Other > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.Other}</div>
                                {rowData.OtherFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.OtherFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.OtherFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.OtherFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.Other}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>
                  <Column flexGrow={50} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>NA</Tooltip>}>
                        <span>NA</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell>
                      {(rowData: EmployeeTeamVM) => {
                        return (
                          <div className="row">
                            {rowData.NA > 0 ? (
                              <div>
                                <div className="col-md-0">{rowData.NA}</div>
                                {rowData.NAFTEAllocation > 0 ? (
                                  <div className="col-md-0 text-success">
                                    ({rowData.NAFTEAllocation})
                                  </div>
                                ) : (
                                  0
                                )}
                                {rowData.NAFTEBuffer > 0 ? (
                                  <div className="col-md-0 text-danger">
                                    ({rowData.NAFTEBuffer})
                                  </div>
                                ) : null}
                              </div>
                            ) : (
                              <div className="col">{rowData.NA}</div>
                            )}
                          </div>
                        );
                      }}
                    </CustomTableCell>
                  </Column>

                  <Column flexGrow={70} fixed>
                    <CustomTableHeaderCells>
                      <Whisper followCursor speaker={<Tooltip>Total</Tooltip>}>
                        <span>Total</span>
                      </Whisper>
                    </CustomTableHeaderCells>
                    <CustomTableCell dataKey="Total" />
                  </Column>
                </ColumnGroup>
              </Table>
            ) : (
              <></>
            )}
            {filteredTeamList && (
              <div style={{ padding: 20 }}>
                <Pagination
                  prev
                  next
                  first
                  last
                  ellipsis
                  boundaryLinks
                  maxButtons={5}
                  size="md"
                  layout={["total", "-", "limit", "|", "pager", "skip"]}
                  total={filteredTeamList.length}
                  limitOptions={[10, 20, 30]}
                  limit={limit}
                  activePage={page}
                  onChangePage={setPage}
                  onChangeLimit={handleChangeLimit}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <TeamDetailSimple />
      )}
    </>
  );
};
